import axios from 'axios';
import { IPhotoItem } from '../domain/PhotoItem';

var rootUrl:string;
if (((window as any).env  && (window as any).env?.REACT_APP_ENV) && (window as any).env?.REACT_APP_API_URL) { 
    rootUrl = (window as any).env?.REACT_APP_API_URL;
}  
else {
    //rootUrl = "https://api.onlinemooring.com";      //production secure domain
    //rootUrl = "https://my.onlinemooring.com:1033";  //production secure
    //rootUrl = "http://my.onlinemooring.com:1032";   //production 

    rootUrl = "https://apitest.onlinemooring.com";  //test secure domain
    //rootUrl = "https://my.onlinemooring.com:1031";  //test secure
    //rootUrl = "http://my.onlinemooring.com:1030";   //test
   
    //rootUrl = "http://localhost:60274";             //localhost
    //rootUrl = "http://api.om.com";                  //local IIS
}

var webUrl:string;
if (((window as any).env  && (window as any).env?.REACT_APP_ENV) && (window as any).env?.REACT_APP_URL) { 
    webUrl = (window as any).env?.REACT_APP_URL;
}
else {
    //webUrl = "http://localhost:8100/";
    webUrl = "https://mtest.onlinemooring.com/";
    //webUrl = "https://m.onlinemooring.com/";
}
interface authData {
    username: string;
    password: string;
    grant_type: string;
}

export const simpleAppVersion = "2023.1.0";
export const appVersion = simpleAppVersion + " W";

export const getServerVersion = async () => {
    let resp = await axios.get(webUrl + "versionDetails.json");
    console.log(resp);
    if (resp && (resp as any).data && (resp as any).data.enabled)
        return (resp as any).data.version;
    return simpleAppVersion;
}

const formatErrorData = (error: any) => {
    return { "url": error?.response?.request?.responseURL, 
             "status": error?.response?.request?.status,
             "statusText": error?.response?.request?.statusText,
             "stack": error?.stack,
             "data": "" };
}

export const uploadPictures = async(token:string, clientId: number, pictureModels: IPhotoItem[], pictureStreams: File[]) => {
    let config = { headers: { 'Authorization': 'Bearer ' + token } };
    let requestUrl = rootUrl + '/PhotoPut?clientId=' + clientId 

    let fd = new FormData();
    fd.append('pictures', JSON.stringify(pictureModels));

    let i = 0;
    pictureStreams.forEach((pictureStream: Blob) => {
        fd.append('pic' + i.toString(), pictureStream);
        i++;
    });

    try {
        const resp = await axios.post(requestUrl, fd, config);
        return resp;
    }
    catch (err) {
        return formatErrorData(err as any);
    }
}

export const getCondition = async(token: string, _clientID:string) => {
    let config = { headers: { 'Authorization': 'Bearer ' + token } };
    let requestUrl = rootUrl + '/Condition/' + _clientID;
   
    try {
        const resp = await axios.get(requestUrl, config);
        return resp;
    }
    catch (err) {
        return formatErrorData(err as any);
    }
}

export const getActivityLogByIdAsync = async(token: string, activityLogId: string ) => {
    let config = { headers: { 'Authorization': 'Bearer ' + token } };
    let requestUrl = rootUrl + '/ActivityLogSearchGet/' + activityLogId;

    try {
        const resp = await axios.get(requestUrl, config);
        return resp;
    }
    catch (err) {
        return formatErrorData(err as any);
    }    
}

export const getActivityLogListAsync = async(token: string, clientID: string, periodType: string, 
    startDate: string, endDate: string, searchPerson: string, 
    searchText: string, getActivityTypeId: number, pinned:boolean, personID: string, isOpen: boolean ) => {
    
    let config = { headers: {'Authorization': 'Bearer ' + token }};
    let newsearchText;
    let newaddsearchPerson;
    let lpinned;
    let lisOpen;
    let lstartDate;
    let lendDate;

    if (searchText === '')
        newsearchText = "null";
    else
        newsearchText = searchText;

    if (searchPerson === "2")
        newaddsearchPerson = "null";
    else
        newaddsearchPerson = searchPerson;

    lpinned = pinned.toString();
    lisOpen = isOpen.toString();

    if (personID ==='') {
        personID = "-1";
    }

    if (startDate === '')
        lstartDate = "null";
    else
        lstartDate = startDate;

    if (endDate === '') 
        lendDate = "null";
    else
        lendDate = endDate;

    let requestUrl = rootUrl + '/ActivityLogSearch/' + clientID + '/' 
                                + periodType + '/'
                                + lstartDate + '/'
                                + lendDate + '/'
                                + newaddsearchPerson + '/'
                                + newsearchText + '/' 
                                + getActivityTypeId.toString() + '/'
                                + lpinned + '/' 
                                + personID + '/'
                                + lisOpen + '/'
                                + 'Android/';

    try {
        const resp = await axios.get(requestUrl, config);
        return resp;
    }
    catch (err) {
        return formatErrorData(err as any);
    }    
}

export const authenticateUserAsync = async(data:authData) => 
{
    let serializeEncodedData: string;
    let str = [];
    str.push(encodeURIComponent("username") + "=" + encodeURIComponent(data.username));
    str.push(encodeURIComponent("password") + "=" + encodeURIComponent(data.password));
    str.push(encodeURIComponent("grant_type") + "=" + encodeURIComponent(data.grant_type));
    serializeEncodedData = str.join("&");

    let config = { headers: { 'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8;' } }

    try {
        const response = await axios.post(rootUrl + "/token", serializeEncodedData, config);
        return response?.data;
    }
    catch (err) {
        return (err as any)?.response?.data;
    }
}

export const getAuthorizedClients = async(token: string, securityObjectValue: string, 
                                            securityActionValue: string, securityLevelValue: string ) => {
    let config = { headers: { 'Authorization': 'Bearer ' + token } };

    try {
        const response =  await axios.get(rootUrl + "/AuthorizedClients/" + securityObjectValue 
                                + "/" + securityActionValue 
                                + "/" + securityLevelValue, config);
        return response.data;
    }
    catch (err) {
        return formatErrorData(err as any);
    }
}

export const getEquipmentList = async(token: string) => {
    let config = { headers: { 'Authorization': 'Bearer ' + token } };
    let requestUrl = rootUrl + '/Equipment';
    
    try {
        const resp = await axios.get(requestUrl, config);
        return resp.data;
    }
    catch (err) {
        return formatErrorData(err as any);
    }
}

export const getRegBoatList = async(token: string) => {
    let config = { headers: { 'Authorization': 'Bearer ' + token } };
    let requestUrl = rootUrl + '/RegBoat';
    
    try {
        const resp = await axios.get(requestUrl, config);
        return resp.data;
    }
    catch (err) {
        return formatErrorData(err as any);
    }
}

export const getRegPersonList = async(token: string) => {
    let config = { headers: { 'Authorization': 'Bearer ' + token } };
    let requestUrl = rootUrl + '/RegPerson';
    
    try {
        const resp = await axios.get(requestUrl, config);
        return resp.data;
    }
    catch (err) {
        return formatErrorData(err as any);
    }
}

export const getPersonForBoat = async(token: string, boatID:string, clientID:string) => {
    let config = { headers: { 'Authorization': 'Bearer ' + token } };
    let requestUrl = rootUrl + '/PersonForBoat/' + boatID + '/' + clientID;
    
    try {
        const resp = await axios.get(requestUrl, config);
        return resp.data;
    }
    catch (err) {
        return formatErrorData(err as any);
    }
}

export const getBoatForPerson = async(token: string, personID:string, clientID:string) => {
    let config = { headers: { 'Authorization': 'Bearer ' + token } };
    let requestUrl = rootUrl + '/BoatForPerson/' + personID + '/' + clientID;
    
    try {
        const resp = await axios.get(requestUrl, config);
        return resp.data;
    }
    catch (err) {
        return formatErrorData(err as any);
    }
}


